import { ProductInterface, ProductVariantInterface } from "@qlevr/shared/interfaces";
import { calculateDiscountPrice } from "../product/get-calculated-discount-price";

export function getDiscountedPriceForItem(product: ProductInterface, variant?: ProductVariantInterface) {
    const price = variant ? variant.price?.amount : 0;
    const discountPercentage = product.discountPercentage ?? 0;
    return calculateDiscountPrice(price, discountPercentage);
}